import { render, staticRenderFns } from "./creditHoursStatistics.vue?vue&type=template&id=b0f93912"
import script from "./creditHoursStatistics.vue?vue&type=script&lang=js"
export * from "./creditHoursStatistics.vue?vue&type=script&lang=js"
import style0 from "./creditHoursStatistics.vue?vue&type=style&index=0&id=b0f93912&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports